import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface UsersTableProps {
}

export const UsersTable: React.FC<UsersTableProps> = () => {

    const usersState = useAppSelector(state => state.users);

    return (
        <>
            <table className="data">
                <thead>
                <tr>
                    <th>Eesnimi</th>
                    <th>Perekonnanimi</th>
                    <th>Kasutajanimi</th>
                    <th>Staatus</th>
                    <th className="right w150"></th>
                </tr>
                </thead>
                <tbody>
                {usersState.users.map(row => {
                    return (
                        <tr key={row.id}>
                            <td>
                                {row.firstname}
                            </td>
                            <td>
                                {row.lastname}
                            </td>
                            <td>
                                {row.username}
                            </td>
                            <td>
                                Administraator
                            </td>
                            <td className="action">
                                <Link to={`/users/${row.id}/modify`}>Muuda</Link>
                                <span>|</span>
                                <Link to={`/users/${row.id}/delete`}>Kustuta</Link>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
            <ul className="table-actions">
                <li>
                    <Link to="/users/new">
                        <strong>Lisa kasutaja</strong>
                    </Link>
                </li>
            </ul>
        </>
    );

}